module.exports = __webpack_public_path__ + "static/media/moods_page.bd7059e6.PNG";